import '../App.css';
import { useState, useEffect } from 'react';
import { useKeycloak } from '../KeycloakContext';

function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);
  const { keycloak, hasRole } = useKeycloak();

  const logos = [
    '/LOGO_ALICE-01.png',
    '/LOGO_ALICE-02.png',
    '/LOGO_ALICE-03.png',
    '/LOGO_ALICE-05.png',
    '/LOGO_ALICE-06.png',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLogoIndex((prevIndex) => (prevIndex + 1) % logos.length);
    }, 1000);

    return () => clearInterval(interval); // Pulisce l'intervallo quando il componente viene smontato
  }, [logos.length]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    if (keycloak) {
      document.cookie = "oauth2_proxy=; Path=/; Domain=.dingegno.com; Expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; HttpOnly";
      document.cookie = "_oauth2_proxy=; Path=/; Domain=.dingegno.com; Expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; HttpOnly";
      keycloak.logout();
    }
  };

  const userInfo = keycloak.tokenParsed || {};
  const userRole = hasRole("SCHOOL") ? "SCHOOL" : hasRole("UNIVERSITY") ? "UNIVERSITY" : "UNKNOWN";

  return (
    <header className="shadow-md p-2 px-5 flex justify-between md:justify-start items-center sticky top-0 z-50 bg-white lg:shadow-none border-black border-b-2">
      <a href="https://silabor.dingegno.com"><img src={logos[currentLogoIndex]} width={'150rem'} /></a>
      <button onClick={toggleMenu} className="lg:hidden">
        <i className="fas fa-bars w-8 h-8"></i>
      </button>
      <nav className={`fixed md:w-full md:flex justify-between top-0 left-0 h-full bg-white transform ${menuOpen ? 'translate-x-0' : '-translate-x-[120%]'} transition-transform lg:relative lg:translate-x-0 lg:flex lg:space-x-3 lg:ml-5 shadow-lg lg:shadow-none lg:bg-transparent py-10 px-6 lg:px-0 lg:py-0`}>
        <div className="md:flex">
          <a href="https://silabor.dingegno.com" className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 px-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2">
            <i className="fas fa-home mr-2"></i>
            Home
          </a>
          <a href="https://orientamento.dingegno.com" className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 px-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2">
            <i className="fas fa-crosshairs mr-2"></i>
            Orientamento
          </a>
          {hasRole("SCHOOL") && (
            <>
              <a href="/" className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 px-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2">
                <i className="fas fa-flask mr-2"></i>
                Laboratori
              </a>
            </>
          )}
          {hasRole("UNIVERSITY") && (
            <>
              <a href="/lab-management" className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2">
                <i className="fas fa-cogs mr-2"></i>
                Gestione laboratorio
              </a>
              <a href="/booking-management" className="block text-base text-sm uppercase font-semibold text-[#000000] py-1 rounded-none flex items-center hover:underline hover:underline-offset-4 hover:decoration-2 mt-4 lg:mt-0">
                <i className="fas fa-calendar mr-2"></i>
                Gestione prenotazioni
              </a>
            </>
          )}
        </div>
        
        <div className="relative mt-[1rem]">
          <button onClick={toggleDropdown} className="flex items-center space-x-2 text-[#3e96ac] hover:text-[#e06615]">
            <img
              src="/avatar.png"
              alt="User Avatar"
              className="w-12 h-12 rounded-full"
              onMouseEnter={(e) => (e.currentTarget.src = '/avatar-hover.png')}
              onMouseLeave={(e) => (e.currentTarget.src = '/avatar.png')}
            />
          </button>
          {dropdownOpen && (
            <div className="absolute mt-2 bg-white border-2 border-black shadow-lg left-[1rem] lg:left-[unset] lg:right-0">
              <div className="p-4">
                <p className='talic font-semibold'>{userInfo.preferred_username}</p>
                <p className="text-sm mt-5 text-lg">{userInfo.given_name} {userInfo.family_name}</p>
                <p className="text-sm mt-1">{userInfo.email}</p>
                <p className="text-sm mt-1">Ruolo: <span className="font-semibold">{userRole}</span></p>
              </div>
              <button className="w-full text-left px-4 py-2 text-sm font-semibold hover:bg-gray-100">
                <a href="/my-bookings"><i className="fa fa-calendar mr-4"></i>Prenotazioni</a>
              </button>
              <button onClick={handleLogout} className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100">Logout</button>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}

export default Navbar;